export default "<button [class]=\"type\" >\n\t<ng-content></ng-content>\n</button>"